<template>
  <div
    :class="darkTheme ? 'list-menu-v1__container-dark' : 'list-menu-v1__container'"
    :style="{
      padding: `0px ${mini ? '0px' : '0px'} 48px ${mini ? '0px' : '0px'} `
    }"
  >
    <v-list-tile
      class="v-test"
      :class="
        item.active
          ? `${
              darkTheme
                ? mini
                  ? 'active-mini'
                  : 'active'
                : mini
                ? 'item-menu-v1 active-mini'
                : 'item-menu-v1 active'
            } `
          : `${darkTheme ? 'item-menu-v1-dark' : 'item-menu-v1'} `
      "
      :name="item.name"
      :color="item.active ? item.color : ''"
      v-for="(item, index) in navItem"
      v-show="!item.hidden"
      @click="changeNavicationRouteItem($event, item)"
      :key="index"
      :title="$t(item.title) ? $t(item.title) : item.name"
      :style="{}"
    >
      <div class="list-menu-v1__content">
        <v-list-tile-action>
          <v-icon :class="item.iconClass" :color="item.active ? item.color : ''">{{
            item.icon
          }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t(item.title) ? $t(item.title) : item.name }}</v-list-tile-title>
        </v-list-tile-content>
      </div>
    </v-list-tile>
  </div>
</template>
<script>
export default {
  name: 'ListMenuV1',
  props: {
    navItem: {
      type: Array
    },
    mini: {
      type: Boolean
    },
    onChangeRoute: {
      type: Function
    }
  },
  methods: {
    handleOnChangeSearchTermMenu(event) {
      const searchTerm = event.target.value
      this.$emit('handleSearchMenu', searchTerm)
    },
    onChangeNavicationMini() {
      this.$emit('changeNavicationMini')
    },
    changeNavicationRouteItem($event, item) {
      this.$emit('onChangeRoute', $event, item)
    }
  },
  computed: {
    darkTheme() {
      const theme = this.$store.getters.theme
      if (!theme) return false
      return theme
    }
  }
}
</script>
<style scoped lang="scss">
.v-list__tile {
  padding: 0 !important;
}

.list-menu-v1__container {
  height: 100%;
  overflow-y: auto;

  .list-menu-v1__content {
    display: flex;
    gap: 12px;

    .v-list__tile__action {
      min-width: auto;
    }
  }

  .active {
    border-radius: 6px;
    background-color: #e6e9ec;
    color: #0050b3;
    //padding: 0 16px;
  }

  .active-mini {
    border-radius: 6px;
    background-color: #e6e9ec;
    color: #0050b3;
    //padding: 0 16px;
  }

  .item-menu-v1 {
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    //padding: 0 16px;

    .item-menu-v1-mini {
      display: flex;
      align-items: center;

      .item-menu__mini-active {
        border-radius: 8px;
        padding: 12px;
        background-color: #e6e9ec;
        color: #096dd9;
      }

      .item-menu__mini {
        padding: 12px;
        border-radius: 8px;
      }

      a {
        padding: 0 !important;

        .v-list__tile__action {
          &:hover {
            color: #0050b3;
            border-radius: 6px;
            background-color: #e6e9ec;
            cursor: pointer;
            margin: 0 16px;
          }

          i {
            color: #0050b3 !important;
          }
        }
      }
    }

    &:hover {
      border-radius: 6px;
      background-color: #e6e9ec;
      cursor: pointer;
      //padding: 0 16px;
    }
  }

  .item-menu-v1-dark {
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    //padding: 0 16px;
    .v-test {
      padding: 0 !important;
    }

    a {
      background: #0050b3 !important;
    }

    .item-menu-v1-mini {
      display: flex;
      align-items: center;

      .item-menu__mini-active {
        border-radius: 6px;
        padding: 12px;
        background-color: #e6e9ec;
        color: #096dd9;
      }

      .item-menu__mini {
        padding: 12px;
        border-radius: 6px;
      }

      a {
        .v-list__tile__action {
          &:hover {
            color: #0050b3;
            border-radius: 6px;
            background-color: #e6e9ec;
            cursor: pointer;
            margin: 0 16px;
          }

          i {
            color: #0050b3 !important;
          }
        }
      }
    }

    &:hover {
      border-radius: 6px;
      background: rgba(255, 255, 255, 0.15);
      cursor: pointer;
    }
  }
}

.list-menu-v1__container-dark {
  height: 100%;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #000;
    border-radius: 6px;
    border: 1px solid #ccc;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #cccc; /* Màu khi hover lên nút cuộn */
  }

  &::-webkit-scrollbar-track {
    background-color: transparent; /* Màu của thanh cuộn */
  }

  .list-menu-v1__content {
    display: flex;
    gap: 12px;

    .v-list__tile__action {
      min-width: auto;
    }
  }

  .active {
    border-radius: 6px;
    background-color: #e6e9ec;
    color: #0050b3;
    //padding: 0 16px;
  }

  .active-mini {
    border-radius: 6px;
    background-color: #e6e9ec;
    color: #0050b3;
    //padding: 0 16px;
  }

  .item-menu-v1 {
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    //padding: 0 16px;
    a {
      padding: 0 !important;
    }

    .item-menu-v1-mini {
      display: flex;
      align-items: center;

      .item-menu__mini-active {
        border-radius: 8px;
        padding: 12px;
        background-color: #e6e9ec;
        color: #096dd9;
      }

      .item-menu__mini {
        padding: 12px;
        border-radius: 8px;
      }

      a {
        padding: 0 !important;

        .v-list__tile__action {
          &:hover {
            color: #0050b3;
            border-radius: 6px;
            background-color: #e6e9ec;
            cursor: pointer;
            margin: 0 16px;
          }

          i {
            color: #0050b3 !important;
          }
        }
      }
    }

    &:hover {
      border-radius: 6px;
      background-color: #e6e9ec;
      cursor: pointer;
      //padding: 0 16px;
    }
  }

  .item-menu-v1-dark {
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    //padding: 0 16px;
    a {
      padding: 0 !important;
      background: #0050b3 !important;
    }

    .item-menu-v1-mini {
      display: flex;
      align-items: center;

      .item-menu__mini-active {
        border-radius: 6px;
        padding: 12px;
        background-color: #e6e9ec;
        color: #096dd9;
      }

      .item-menu__mini {
        padding: 12px;
        border-radius: 6px;
      }

      a {
        .v-list__tile__action {
          &:hover {
            color: #0050b3;
            border-radius: 6px;
            background-color: #e6e9ec;
            cursor: pointer;
            margin: 0 16px;
          }

          i {
            color: #0050b3 !important;
          }
        }
      }
    }

    &:hover {
      border-radius: 6px;
      background: rgba(255, 255, 255, 0.15);
      cursor: pointer;
    }
  }
}
</style>
